module.exports = __webpack_public_path__ + "static/img/laohu.ceed68ad.png";